import React from 'react';

export const AskDocs = () => {
    return (
        <iframe
            style={{ flex: '1 1 0', height: '100vh' }}
            src="https://tse-app-builder.vercel.app/complete?embed=true"
            frameBorder="0"
            id="iframe"
        />
    );
};
